import { render, staticRenderFns } from "./PostbacksConstructor.vue?vue&type=template&id=2b106792&"
import script from "./PostbacksConstructor.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PostbacksConstructor.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PostbacksConstructor.vue?vue&type=style&index=0&id=2b106792&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports